import * as React from 'react';
import { useSelector } from 'react-redux';
import { orgPlanSelector } from '../../../redux/app/selectors/organization';

interface SubscriptionDetailsQuickAddOnSectionProps {
  handleClick: (any) => void;
}

export const SubscriptionDetailsQuickAddOnSection = ({
  handleClick,
}: SubscriptionDetailsQuickAddOnSectionProps) => {
  const plan = useSelector(orgPlanSelector);
  const isTrialPlan = plan === 'trial-plan-4';

  return (
    <div className="body">
      <p className="fsz-16 bold-900 mb-5">Add more to balance</p>
      <div className="content flex justify-between">
        <div className="col-left">
          <p className="fsz-13">Running low on you balance? Quickly recharge your account through your default payment method anytime.</p>
        </div>
        <div className="col-right">
          <button
            type="button"
            className="button sand height-fit-content width-100"
            data-checkouttype="addBalance"
            onClick={handleClick}
            disabled={isTrialPlan}
          >
            Add Balance
          </button>
        </div>
      </div>
    </div>
  );
};
